import { useEffect, useState } from "react";
import { useField } from "../../../hooks/FormGeneratorHooks";
import { FormGroup } from "./FormGroup";

// Table answers are persisted as a JSON string of { [rowLabel]: optionValue }
// but held as an object while editing; accept either and make sure every
// configured row has a key.
const parseTableValue = (rawValue: any, lignes: any[] = []) => {
  let parsed: any = rawValue;
  if (typeof rawValue === "string") {
    try {
      parsed = JSON.parse(rawValue);
    } catch (error) {
      parsed = null;
    }
  }

  const result: any = {};
  lignes.forEach((l) => {
    result[`${l.label}`] = "";
  });

  if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
    Object.assign(result, parsed);
  }

  return result;
};

export const TableField = (props) => {
  const {
    errorMessage,
    id,
    setValue,
    value,
    isValid,
    otherProps,
    valueDebounced,
  } = useField(props);

  const { required, name } = props;
  const { children, label, options, helper, validMessage, ...rest } =
    otherProps;
  const showError = required;
  const formGroupProps = {
    errorMessage,
    helper,
    id,
    isRequired: required,
    label,
    showError,
    name,
    ...rest,
  };

  const [preValue, setPreValue] = useState(false);

  // Start from the saved answers (persisted as a JSON string) instead of
  // resetting every row to "": the reset hid saved answers, made row-based
  // conditions (e.g. "row = Yes" → show dates) evaluate as unanswered, and
  // the next submit overwrote the untouched rows with "".
  const lignesKey = (props.lignes || []).map((l) => l.label).join("||");
  useEffect(() => {
    setValue(parseTableValue(props.value, props.lignes));
  }, [lignesKey, props.value]);

  return (
    <FormGroup {...formGroupProps}>
      <table
        onMouseLeave={() => {
          if (props?.onSumbit && preValue) {
            props?.onSumbit({
              fieldName: name,
              value: JSON.stringify(value),
              isValid: true,
            });

            setPreValue(false);
          }
        }}
        className="self-center shadow-md bg-white rounded-lg  "
      >
        <th
          className="bg-gray-400 border px-2 py-2    color-white w-96"
          key={"patient"}
        ></th>
        {props.options.map((item) => {
          return (
            <th
              className="bg-gray-400 border px-1 text-center py-2 color-white font-medium w-96 "
              key={item.label}
            >
              {item.label}
            </th>
          );
        })}

        {props.lignes.map((item, k) => {
          return (
            <tr className="border py-2  ">
              <td
                style={{ width: "130px" }}
                className="font-bold p-2 bg-gray-200  "
              >
                {item.label}
              </td>
              {props.options.map((opt, i) => {
                return (
                  <td className="  px-1 py-2 border text-center ">
                    <input
                      type={"radio"}
                      value={opt.value}
                      name={`${name}.${item.label}`}
                      checked={value?.[`${item.label}`] === opt.value}
                      onChange={async (e) => {
                        const rowValue = e.target.value;
                        // Return a new object: mutating `current` in place kept
                        // the same reference, so fields conditioned on this
                        // row were not re-evaluated.
                        await setValue((current) => ({
                          ...parseTableValue(current, props.lignes),
                          [`${item.label}`]: rowValue,
                        }));
                        setPreValue(true);
                      }}
                      // onBlur={(e) => {
                      //   if (value && props?.onSumbit) {
                      //   }
                      // }}
                      disabled={props.disabled ? true : false}
                      required={required}
                    ></input>
                  </td>
                );
              })}
            </tr>
          );
        })}
      </table>

      {children}
    </FormGroup>
  );
};
